import { useServiceCache } from '@/providers/ServiceCacheContext'
import { CircularProgress, styled } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import React, { useMemo } from 'react'
import { TrustedSvg } from './TrustedSvg'

interface ServiceDetailsProps {
  service: string
  children?: React.ReactNode
  mode?: 'desktop' | 'mobile'
}

export const ServiceDetails = (props: ServiceDetailsProps) => {
  const {
    loading: servicesLoading,
    getServiceForCode,
  } = useServiceCache()
  const { service, children, mode = 'desktop' } = props

  const serviceObject = useMemo(() => getServiceForCode(service), [service, getServiceForCode])

  const hungarianName = useMemo(() => {
    return serviceObject?.name || service
  }, [service, serviceObject])

  if (servicesLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'end',
          height: '100%',
        }}
      >
        <CircularProgress sx={{ mb: 2 }} />
      </div>
    )
  }

  if (mode === 'desktop') {
    return (
      <Box sx={{ textAlign: 'center' }}>
        {serviceObject?.svg && <TrustedSvg width={80} height={80} svgString={serviceObject.svg} />}
        <ServiceName
          sx={{
            marginTop: 3,
            fontSize: hungarianName.length > 35 ? '0.9rem' : undefined,
          }}
          variant="body1"
        >
          {hungarianName}
        </ServiceName>
        {children}
      </Box>
    )
  }

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {serviceObject?.svg && <TrustedSvg width={80} height={80} svgString={serviceObject.svg} />}
        <Typography variant="h6" sx={{ paddingLeft: 1.5 }}>
          {hungarianName}
        </Typography>
      </Box>
      {children}
    </>
  )
}

const ServiceName = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    marginTop: theme.spacing(1),
    fontSize: '0.9rem',
  },
}))

const Image = styled('img')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    width: 50,
    height: 50,
  },
}))
